import zh_CN from './zh_CN'
import en from './en'
import ja from './ja'
import ko from './ko'
import de from './de'
import fr from './fr'
import ru from './ru'
import th from './th'
import es from './es'
import pt from './pt'

/**
 * 由于主应用预渲染打包默认为英文，这里需要将中英文对调
 */
export default {
  'zh-cn': zh_CN,
  'ru-RU': ru,
  en: en,
  ja: ja,
  ko: ko,
  de: de,
  fr: fr,
  th: th,
  es: es,
  pt: pt
}
